import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export type SnackbarVariant = 'success' | 'error' | 'info' | 'warning';

export interface SnackbarData {
  variant: SnackbarVariant;
  /** Bold headline (Figma: Roboto Medium 16/24). */
  title: string;
  /** Optional supporting line (Figma: Roboto Regular 14/20). */
  message?: string;
}

/** Leading icon per variant — Material glyphs matching the OVS alert design. */
const VARIANT_ICON: Record<SnackbarVariant, string> = {
  success: 'check',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

/**
 * Shared toast body rendered inside MatSnackBar (Figma node 1083-112463). One
 * coloured card per variant with a leading icon, a bold title, an optional
 * message, and a close button. Opened via NotificationService — not directly.
 */
@Component({
  selector: 'csd-snackbar',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent {
  readonly data = inject<SnackbarData>(MAT_SNACK_BAR_DATA);
  private readonly ref = inject<MatSnackBarRef<SnackbarComponent>>(MatSnackBarRef);

  readonly icon = VARIANT_ICON[this.data.variant];

  dismiss(): void {
    this.ref.dismiss();
  }
}
